export default {"src":"/_next/static/media/care-team-at-work-emotional.colour.3ceeb788.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};